export interface MarketplacePlugin {
  api_name: string;
  config_template: Record<string, any>;
  created: string;
  description?: string;
  external_link?: string;
  id: string;
  managed_by_business: {
    id: string;
    name: string;
    reply_to_email: string;
  };
  name: string;
  published: true;
  thumbnail?: string;
  updated?: string;
  forceEnable?: boolean;
  editConfigurationOverride?: string | (() => void);
  base_config?: {
    secrets?: Array<string>;
    user_configurable?: boolean;
  };
}

export interface InstalledPlugin {
  name: string;
  business_config: Record<string, any>;
}

export enum MarketPlacePluginApiName {
  KizenAI = 'kizen_ai',
}
